import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import ExpandMenu from "./ExpandMenu";

const Drawer = ({ isOpen, toggleDrawer, routes }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && <Backdrop onClick={toggleDrawer} />}
      <SDrawer isOpen={isOpen}>
        <RightNav>
          <NavRoutes>
            {routes.map((route) => {
              if (route.subRoutes) {
                return <ExpandMenu route={route} key={route.name} />;
              }
              return (
                <NavRoute onClick={toggleDrawer} to={route.link} key={route.name}>
                  {route.name}
                </NavRoute>
              );
            })}
          </NavRoutes>
        </RightNav>
      </SDrawer>
    </>
  );
};

export default Drawer;

const Backdrop = styled.div`
  height: 100%;
  width: 100%;
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  transition: 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
`;

const SDrawer = styled.div`
  z-index: 150;
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 80px;
  padding-bottom: 80px;
  height: 100vh;
  width: 80%;
  background-color: white;
  transition: 0.3s ease;
  transform: translateX(${(props) => (props.isOpen ? "0" : "-100%")});
  overflow-y: auto;

  @media (min-width: 600px) {
    width: 40%;
  }

  @media (min-width: 479px) {
    width: 60%;
  }
`;

const RightNav = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
`;

const NavRoutes = styled.div``;

const NavRoute = styled(Link)`
  display: flex;
  text-decoration: none;
  color: black;
  font-size: 20px;
  padding: 15px;
`;
